<template>
  <Layout footer>
    <div class="app-container_onlinedetail app-container_warp">
      <div class="onlinedetail_top">
        <div class="flex items-center py-5 text-base border-gray-300" style="padding: 0">
          <span class="mr-1">当前位置：</span>
          <NBreadcrumb>
            <NBreadcrumbItem @click="gotoHome">首页</NBreadcrumbItem>
            <NBreadcrumbItem @click="gotoOnline">在线学习</NBreadcrumbItem>
            <NBreadcrumbItem>{{ detailData.courseName }}</NBreadcrumbItem>
          </NBreadcrumb>
        </div>
        <div class="flex mt-8">
          <div class="video-wrapper bg-gray-400" id="dplayer"></div>
          <div class="flex-1">
            <NEmpty class="mt-10" description="暂无数据" v-if="!loading && chapterVo.length === 0" />
            <NSpin :show="loading" size="large" v-else style="height: 100%">
              <template v-if="!loading">
                <h1 class="text-xl mt-2" style="
                    height: 29px;
                    font-size: 30px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #000000;
                  ">{{ detailData.courseName }}</h1>
                <div class="mb-6 mt-5 text-base space-y-1" style="
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #666666;
                    line-height: 48px;
                  ">
                  <p class="flex" style="align-items: center">
                    <el-image style="width: 26px; height: 28px; margin-right: 14px"
                      src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/online_left_logo/credit.png">
                    </el-image>
                    课程学分：共
                    <span style="
                        display: inline-block;
                        font-size: 24px;
                        font-family: CenturySchoolbook;
                        font-weight: 400;
                        color: #fe0a0a;
                      ">
                      {{ detailData.duration }}
                    </span>
                    分
                  </p>

                  <p class="flex" style="align-items: center">
                    <el-image style="width: 26px; height: 32px; margin-right: 14px"
                      src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/online_left_logo/teacher.png">
                    </el-image>授课讲师：{{ detailData.teacherName || '智慧人才' }}
                  </p>
                  <!-- <p>
                    学习人次：
                    <span style="color: #DF1A23">{{ detailData.learnCount }} </span>
                  </p> -->
                </div>
                <div class="leading-6" style="font-size: 18px; line-height: 36px">
                  <span style="color: #df1a23">说明：</span>
                  适用于符合职业技能培训政策的学员；模拟考试不限制次数；多次正式考试取最优成绩，建议先模拟后再参加正式考试。（备注：60分及格）
                  <br />
                  <span style="color: #df1a23">
                    学习不超过1分钟不记录学分，平台执行每1分钟自动记录学分制，请尽量观看1分钟以上，避免丢失学分！
                  </span>
                </div>
                <div class="mt-5">
                  <el-button type="primary" @click="handleStudy()" style="background-color: #66a6ff; border: none">开始学习
                  </el-button>
                  <el-button type="primary" class="ml-4" style="background-color: #66a6ff; border: none"
                    @click="router.push('/learning-center/exams')">
                    认证考试
                  </el-button>
                </div>
              </template>
            </NSpin>
          </div>
        </div>
      </div>

      <div class="border-gray-300 mt-7" style="background-color: #fff; border-radius: 10px; overflow: hidden">
        <n-tabs type="line" :tab-style="`font-size:24px;width:206px;text-align: center;  display: flex;
  justify-content: center;`">
          <n-tab-pane :name="0" tab="课程目录">
            <NEmpty class="mt-10" description="暂无数据" v-if="!loading && chapterVo.length === 0" />
            <NSpin :show="loading" size="large" v-else :class="{ 'my-10': loading }">
              <div class="px-4 py-4" style="padding: 50px; font-size: 17px">
                <template v-for="(group, groupIndex) in chapterVo" :key="group.id">
                  <div class="flex justify-between items-center text-base mb-2" style="font-size: 17px"
                    :class="{ 'mt-4': groupIndex > 0 }">
                    <span>{{ group.name }}</span>
                    <span>共 {{ group.chapterAll }} 学分，已学 {{ group.chapterLearn }} 学分</span>
                  </div>
                  <div class="flex items-center text-sm pl-8 pr-4 py-1" style="font-size: 16px"
                    v-for="(item, index) in group.sectionVO" :key="item.id">
                    <div class="flex items-center p-1 classitem">
                      <n-icon size="18">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 24 24" v-if="payVideoId !== item.id">
                          <g fill="none">
                            <path
                              d="M10.856 8.155A1.25 1.25 0 0 0 9 9.248v5.504a1.25 1.25 0 0 0 1.856 1.093l5.757-3.189a.75.75 0 0 0 0-1.312l-5.757-3.189zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2zM3.5 12a8.5 8.5 0 1 1 17 0a8.5 8.5 0 0 1-17 0z"
                              fill="currentColor"></path>
                          </g>
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 24 24">
                          <g fill="none">
                            <path
                              d="M10.5 8.25a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0v-7.5zm4.5 0a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0v-7.5zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2zM3.5 12a8.5 8.5 0 1 1 17 0a8.5 8.5 0 0 1-17 0z"
                              fill="currentColor"></path>
                          </g>
                        </svg>
                      </n-icon>
                      <span class="rounded bg-gray-200 ml-2 mr-1" style="padding: 2px 6px; line-height: 14px">
                        {{ item.sort }}
                      </span>
                      <!--<NPopover placement="right" show>-->
                      <!--  <template #trigger>-->
                      <!--    <div class="relative">-->
                      <!--      <span>{{ item.name }}</span>-->
                      <!--    </div>-->
                      <!--  </template>-->
                      <!--  <span>正在学习中</span>-->
                      <!--</NPopover>-->
                      <div class="relative" :class="{ active: payVideoId === item.id }" @click="
                          toggleClassVideo({
                            group,
                            groupIndex,
                            item,
                            itemIndex: index,
                          })
                        ">
                        <span>{{ item.name }}</span>
                      </div>
                    </div>
                    <span class="ml-auto mr-4">
                      共 {{ item.sectionAll === '0' ? '1' : item.sectionAll }} 分钟，已学
                      {{ item.sectionLearn }} 分钟
                    </span>
                    <!--                    v-if="item.sectionLearn && item.sectionLearn > 0"-->
                    <!--                    :percentage="Math.floor((item.sectionLearn / item.sectionAll) * 100)"-->
                    <n-progress style="width: 38px" type="circle" color="#eb5405" :percentage="
                        Math.floor(
                          (Number(item.sectionLearn) /
                            Number(item.sectionAll === '0' ? '1' : item.sectionAll)) *
                            100,
                        )
                      " />
                    <!--                    <div v-else style="width: 38px"></div>-->
                  </div>
                </template>
              </div>
            </NSpin>
          </n-tab-pane>
          <n-tab-pane :name="1" tab="课程简介">
            <div class="vhtml" style="
                padding: 50px;
                font-size: 20px;
                text-indent: 40px;
                line-height: 30px;
                letter-spacing: 1px;
              " v-html="detailData.course"></div>
          </n-tab-pane>
          <n-tab-pane :name="2" tab="课程评价">
            <ClassEvaluate style="padding: 50px" :data="detailData"></ClassEvaluate>
          </n-tab-pane>
        </n-tabs>
      </div>
    </div>
  </Layout>

  <n-modal v-model:show="showTips" preset="dialog" title="提示" :content="tipsMsg" :mask-closable="false"
    positive-text="确认" @positive-click="handleShowTipsConfirm" />

  <n-modal v-model:show="showZhagnjie" :mask-closable="false">
    <n-card style="width: 400px" title="温馨提示" :bordered="false" size="huge">
      <div class="ml-8">请点击确认 进入{{ dtTitle }}</div>
      <div style="text-align: right">
        <n-button type="info" @click="ceshiConfirm">确认</n-button>
      </div>
    </n-card>
  </n-modal>

  <!--  章节测试题-->
  <n-modal v-model:show="showceshi" :mask-closable="false">
    <n-card style="width: 600px" title="" :bordered="false" size="huge">
      <div style="text-align: center" v-if="dtTitle == '章节测试'">
        {{ dtTitle }}
        <span v-if="chapterTestInfo.answerTimes"> ({{ chapterTestInfo.answerTimes }}s) </span>
      </div>
      <div v-for="(item, index) in testShuzu" :key="index">
        <div class="ml-8" v-if="item.questionType === 0">单选题</div>
        <div class="ml-8" v-if="item.questionType === 1">多选题</div>
        <div class="ml-8" v-if="item.questionType === 2">判断题</div>

        <div class="ml-12">
          <span>{{ index + 1 }} .</span> {{ item.name }}
        </div>
        <div class="ml-20" v-for="(items, indexs) in item.questionAnswerList" :key="indexs">
          <div v-if="item.questionType === 0 || item.questionType === 2">
            <el-radio-group v-model="item.radio">
              <el-radio :label="items.id">{{ items.answerContent }}</el-radio>
            </el-radio-group>
          </div>
          <div v-if="item.questionType === 1">
            <el-checkbox v-model="items.fuxuankuang">{{ items.answerContent }}</el-checkbox>
          </div>
        </div>
      </div>
      <div style="text-align: right">
        <div v-show="!answerFlag" style="padding: 20px">答题错误</div>
        <n-button type="info" v-if="answerFlag" @click="tisubmit">确认</n-button>
        <n-button type="info" v-if="!answerFlag" @click="resubmitJishi">重新答题</n-button>
      </div>
    </n-card>
  </n-modal>
  <el-dialog @open="openss" v-model="centerDialogVisibles" title="活体检测" width="800px" align-center :show-close="false"
    :close-on-press-escape="false" :append-to-body="true" :close-on-click-modal="false">
    <template v-if="openvideoSuppops">
      <div style="text-align: center; font-size: 20px; font-weight: 800; padding: 10rpx">
        人脸识别
        <span v-if="recognitionInfo.timeLimit > 0">({{ recognitionInfo.timeLimit }}s)</span>
        <span v-if="recognitionInfo.timeout" style="color: red">(已超时)</span>
      </div>
      <div style="text-align: center; font-size: 18px">
        {{
          recognitionInfo.timeLimit != -1
            ? '请在倒计时内完成人脸识别，超时将判定为不在现场，累计一定次数删除课时'
            : '完成人脸识别后可继续观看视频'
        }}
      </div>
    </template>
    <template v-else>
      <div style="text-align: center; font-size: 20px; font-weight: 800; padding: 10rpx">
        {{ openvideoSuppoptitle }}
      </div>
      <div style="text-align: center; font-size: 18px">
        人脸识别失败，人脸识别通过后可继续观看视频，点击确定再次进行识别
      </div>
    </template>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="recognitionInfoclick">确定</el-button>
      </span>
    </template>
  </el-dialog>
  <el-dialog v-model="centerDialogVisible" title="活体检测" width="800px" align-center :show-close="false"
    :close-on-press-escape="false" :close-on-click-modal="false">
    <EsandLiving @change="livingdetect" v-if="centerDialogVisible"></EsandLiving>
    <template #footer>
      <!-- <span class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
      </span> -->
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, onBeforeUnmount, nextTick, computed, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Layout from '@/components/Layout';
import ClassEvaluate from '@/views/learning-center/ClassEvaluate';
import { ElMessage, ElMessageBox } from 'element-plus';
import EsandLiving from '@/components/EsandLiving';

import {
  getClassDetailApi,
  recordVideoPlayCreditApi,
  chapterTest,
  instantAnswer,
  verifyOnlineClass,
  getPlayInfo,
  getClassParamByKey,
  videoSupervise,
  saveFaceSnapshotapi,
  addTestRecordNewapi,
  appfaceauditrecordSave,
} from '@/api';
import Hls from 'hls.js';

import DPlayer from 'dplayer';
const wathc_video_order_need = ref(false);
getClassParamByKey({ key: 'wathc_video_order_need' }).then(res => {
  console.log(res);
  if (res && res.data && res.data == 2) {
    wathc_video_order_need.value = true;
  }
});
const router = useRouter();
const route = useRoute();
const store = useStore();

const isLogin = computed(() => Boolean(store.state.token));
function checkLogin () {
  if (isLogin.value || route.query.type == 1) {
    return true;
  }
  window.message.warning('您未登录，请先登录');
  return false;
}

function gotoHome () {
  router.push('/');
}
function gotoOnline () {
  router.push('/learning-center/online');
}
var timing = ref(null);
const testData = ref({});
const testShuzu = ref([{}]);
const showZhagnjie = ref(false);
// 章节测试 时间
const zhangjie = ref({
  sectionId: '', // 小节id
  time: -1, // 章节测试 时间
  vieoOverallTime: 0, // 视频总时长
  Gkwatch: 0, // 上次观看视频位置
});
const showceshi = ref(false);
const dtTitle = ref('章节测试');

let dp = null;
const loading = ref(true);
const detailData = ref({});
const chapterVo = ref([]);
// 正在播放的视频id
const payVideoId = ref(null);
// getClassDetailApi(route.params.id)
//   .then(res => res.data)
//   .then(res => {
//     chapterVo.value = res.chapterVo;
//     // 首次进来 如果不是空 把 小节 指定时长章节测试时间 存起来
//     // console.log('@@@@@@@@@@@@@@@');
//     if (chapterVo.value.length !== 0) {
//       zhangjie.value.sectionId = chapterVo.value[0].sectionVO[0].id;
//       // zhangjie.value.time = chapterVo.value[0].sectionVO[0].sectionAll;
//     }
//     delete res.chapterVo;
//     detailData.value = res;

//     setupVideo();
//   })
//   .finally(() => {
//     loading.value = false;
//   });
getClassDetailApifun();
function getClassDetailApifun () {
  getClassDetailApi(route.params.id)
    .then(res => res.data)
    .then(res => {
      chapterVo.value = res.chapterVo;
      // 首次进来 如果不是空 把 小节 指定时长章节测试时间 存起来
      // console.log('@@@@@@@@@@@@@@@');
      if (chapterVo.value.length !== 0) {
        zhangjie.value.sectionId = chapterVo.value[0].sectionVO[0].id;
        // zhangjie.value.time = chapterVo.value[0].sectionVO[0].sectionAll;
      }
      delete res.chapterVo;
      detailData.value = res;

      setupVideo();
    })
    .finally(() => {
      loading.value = false;
    });
}
// 获取视频地址
const videoUrl = ref('');
let videoSuperviseList = null;
const recognitionInfo = ref(null);
let recognitiontimer = null;
let recognitionpops = true;
function resolveAfter2Seconds (videoID, sectionId) {
  return new Promise(function (resolve, reject) {
    videoUrl.value = '';
    getPlayInfo(videoID).then(res => {
      videoUrl.value = res.data;
      getvideoSupervise(sectionId).then(res => {
        resolve();
      });
      //
    });
  });
}
function getvideoSupervise (sectionId) {
  if (route.query.type == 1) {
    return;
  }
  return videoSupervise({ sectionId }).then(res => {
    videoSuperviseList = res.data;
    console.log(123, videoSuperviseList);
  });
}

const imgBaseUrl = 'https://qingjuck.oss-cn-shanghai.aliyuncs.com/';
const isFinished = ref(false);
async function setupVideo () {
  // learnedLastTimeFlag=2代表没有上一次观看记录 learnedLastTimeFlag=1代表有观看记录
  let learnedLastTimeFlag = 2;
  // 循环 找出 最后观看记录的小节 learnedLastTime=1 是最后一次观看
  for (let i = 0; i < chapterVo.value.length; i++) {
    chapterVo.value[i].zhangkey = i;
    for (let x = 0; x < chapterVo.value[i].sectionVO.length; x++) {
      chapterVo.value[i].sectionVO[x].xiabiao = x;
      if (chapterVo.value[i].sectionVO[x].learnedLastTime === 1) {
        learnedLastTimeFlag = 1;
        // console.log('有关看过');
        console.log(chapterVo.value[i].sectionVO[x], '有关看过');
        if (
          chapterVo.value[i].sectionVO[x].sectionAll ===
          chapterVo.value[i].sectionVO[x].sectionLearn
        ) {
          isFinished.value = true;
        } else {
          isFinished.value = false;
        }
        console.log(chapterVo.value[i].sectionVO[x].id);
        await resolveAfter2Seconds(
          chapterVo.value[i].sectionVO[x].aliPlay,
          chapterVo.value[i].sectionVO[x].id,
        );
        setTimeout(() => {
          // console.log(videoUrl.value);
          let videoUrltype = 'auto';
          if (validationEnd(videoUrl.value, '.m3u8')) {
            videoUrltype = 'customHls';
          }
          dp = new DPlayer({
            container: document.getElementById('dplayer'),
            hotkey: false,
            contextmenu: [],
            video: {
              // url: chapterVo.value[i].sectionVO[x].aliPlayUrl,
              url: videoUrl.value,
              type: videoUrltype,
              customType: {
                customHls: function (video, player) {
                  const hls = new Hls();
                  hls.loadSource(video.src);
                  hls.attachMedia(video);
                },
              },
            },
          });

          // sectionAll sectionLearn
          if (
            chapterVo.value[i].sectionVO[x].sectionAll ===
            chapterVo.value[i].sectionVO[x].sectionLearn
          ) {
            dp.seek(0);
          } else {
            dp.seek(chapterVo.value[i].sectionVO[x].learnedLastHour / 1000);
          }
          currentGoVo = chapterVo.value[i];
          currentGoVoIndex = chapterVo.value[i].zhangkey;
          currentGoVoItem = chapterVo.value[i].sectionVO[x];
          currentGoVoItemIndex = chapterVo.value[i].sectionVO[x].xiabiao;
          payVideoId.value = chapterVo.value[i].sectionVO[x].id; // 视频小节 id
          // console.log(chapterVo.value[i].sectionVO[x].aliPlayUrl);
          // console.log(chapterVo.value[i].sectionVO[x].id);
          // console.log(chapterVo.value[i].sectionVO[x].name);
          // console.log(chapterVo.value[i].sectionVO[x].learnedLastHour);
          // console.log(chapterVo.value[i]);
          // console.log(chapterVo.value[i].sectionVO[x]);

          let aa = document.getElementsByClassName('dplayer-bar-wrap');
          if (
            chapterVo.value[i].sectionVO[x].sectionAll ===
            chapterVo.value[i].sectionVO[x].sectionLearn
          ) {
            document.getElementsByClassName('dplayer-bar-wrap')[0].style.display = 'block';
            // console.log(aa[0]);
          } else {
            document.getElementsByClassName('dplayer-bar-wrap')[0].style.display = 'none';
          }
        }, 500);
      }
    }
  }
  if (learnedLastTimeFlag === 2) {
    // console.log('没有观看过');
    resolveAfter2Seconds(
      chapterVo.value[0].sectionVO[0].aliPlay,
      chapterVo.value[0].sectionVO[0].id,
    );
    setTimeout(() => {
      let videoUrltype = 'auto';
      if (validationEnd(videoUrl.value, '.m3u8')) {
        videoUrltype = 'customHls';
      }
      dp = new DPlayer({
        container: document.getElementById('dplayer'),
        hotkey: false,
        contextmenu: [],
        video: {
          pic: imgBaseUrl + detailData.value.profilePicture,
          url: isLogin.value || route.query.type == 1 ? videoUrl.value : null,
          type: videoUrltype,
          customType: {
            customHls: function (video, player) {
              const hls = new Hls();
              hls.loadSource(video.src);
              hls.attachMedia(video);
            },
          },
        },
      });
      // console.log('自动视频' + videoUrl.value);
      currentGoVo = chapterVo.value[0];
      currentGoVoIndex = 0;
      currentGoVoItem = chapterVo.value[0].sectionVO[0];
      currentGoVoItemIndex = 0;
      payVideoId.value = chapterVo.value[0].sectionVO[0].id; // 视频小节 id
      // 视频正在播放中 图标 开始 暂停 是根据 视频小节id 来判断的
    }, 500);
  }
  setTimeout(() => {
    dp.on('waiting', () => {
      clearInterval(timing);
      console.log('缓冲中 ~~~');
      pauseRecord();
    });
    dp.on('playing', () => {
      if (route.query.type == 1) {
        document.getElementsByClassName('dplayer-bar-wrap')[0].style.display = 'block';
      } else {
        nowDuration();
      }

      console.log('播放准备开始 ~~~');
      isLogin.value && continueRecord();
    });
    dp.on('pause', () => {
      clearInterval(timing);
      // console.log('视频暂停了 ~~~');
      // 记录视频的总时长
      zhangjie.value.vieoOverallTime = parseInt(dp.video.duration * 1000);
      isLogin.value && pauseRecord();
    });
    dp.on('play', () => {
      clearInterval(timing);
      console.log('播放开始 ~~~');
      videoCheckout();
      if (checkLogin()) {
        continueRecord();
      } else {
        dp.pause();
      }
    });
    dp.on('ended', () => {
      clearInterval(timing);
      // console.log('视频播放结束 ~~~');
      stopRecord();
      // playNext(); // 播放完自动 播放下一下节
      sectionTest(); // 视频 播放完 调用 章节测试接口
      lessSixty(); // 视频小于60秒
    });
    // 视频播放当前时长
    dp.on('timeupdate', () => {
      let timeDisplay = Math.floor(dp.video.currentTime);
      if (videoSuperviseList && videoSuperviseList.supervisePoint) {
        let datas = {};
        try {
          videoSuperviseList.supervisePoint.forEach(itemi => {
            let datitime = parseInt(itemi.triggerTime / 1000);
            if (timeDisplay == datitime && itemi.passFlag == 0) {
              dp.pause();
              datas = itemi;
              throw 'datas';
            }
          });
        } catch (e) {
          console.log(e, datas);
          if (e == 'datas') {
            recognitionInfo.value = {
              timeLimit: videoSuperviseList.waitingTime * 60,
              actionType: 1,
              ...datas,
            };
            openvideoSupervise();
          }
        }
      }
    });
  }, 600);
}

let step = 120;
let timer = null;

function handleRecord () {
  timer = setInterval(() => {
    step--;
    if (step === 0) {
      stopRecord();
      // console.log('记录分数 ~~~');
      handleRecordService(parseInt(dp.video.currentTime * 1000));
    }
  }, 1000);
}

// 当前 视频 播放 时长
function nowDuration () {
  dtTitle.value = '及时答题';
  instantAnswer({ sectionId: zhangjie.value.sectionId }).then(res => {
    testData.value = res.data;
  });
  timing = setInterval(function () {
    // console.log('当前视频播放到' + Math.floor(dp.video.currentTime));
    // 遍历 取出 指定视频 答题时间 sectionTime
    if (testData.value.questionBankVOList.length !== 0) {
      for (let i = 0; i < testData.value.questionBankVOList.length; i++) {
        if (
          Math.floor(dp.video.currentTime) ===
          Number(testData.value.questionBankVOList[i].sectionTime / 1000)
        ) {
          testShuzu.value[0] = testData.value.questionBankVOList[i];
          // console.log(testShuzu);
          // dp.pause();
          // showZhagnjie.value = true;
          // testData.value = res.data;
        }
      }
    }
  }, 1000);
}
// 进去 及时答题
function ceshiConfirm () {
  showZhagnjie.value = false;
  showceshi.value = true;
}
function resubmitJishi (params) {
  let datac = testShuzu.value;
  // datac.forEach(item => {
  //   item.questionAnswerList.forEach(i => {
  //     i.isChoose = 0
  //     if (item.questionType == 0 || item.questionType == 2) {
  //       item.radio = ''
  //     }
  //     if (item.questionType == 1) {
  //       i.fuxuankuang = false
  //     }
  //   })
  // })
  // answerFlag.value = true
  sectionTest();
}
// 及时答题 提交
function tisubmit () {
  // let datac = testData.value.questionBankVOList;
  let datac = testShuzu.value;
  clearInterval(chapterTestInfotimer);
  datac.forEach(item => {
    item.questionAnswerList.forEach(i => {
      i.isChoose = 0;
      if (item.questionType == 0 || item.questionType == 2) {
        if (item.radio == i.id) {
          console.log(item.radio);
          i.isChoose = 1;
        }
      }
      if (item.questionType == 1 && i.fuxuankuang) {
        i.isChoose = 1;
      }
    });
  });
  let data = {
    questionBankVOList: datac,
  };
  if (dtTitle.value == '章节测试') {
    data.examPaperId = chapterTestInfo.value.examPaperId;
    data.testType = chapterTestInfo.value.testType;
    data.examSnapshotId = chapterTestInfo.value.examSnapshotId;
    data.sectionId = chapterTestInfo.value.sectionId;
  }
  addTestRecordNew(data);
  return;
  for (let i = 0; i < datac.length; i++) {
    // console.log(datac);
    // // 选判断类型
    if (datac[i].questionType === 0 || datac[i].questionType === 2) {
      if (datac[i].answerAnalysis !== datac[i].radio) {
        // console.log(datac[i]);
        // console.log(datac.value[i]);
        dp.seek(0);
        showceshi.value = false;
        window.message.error('答题错误');
        return console.log('答案错误');
      }
    }
    if (datac[i].questionType === 1) {
      // 判断 多选题 选项 是否 选中
      let duo = [];
      for (let d = 0; d < datac[i].questionAnswerList.length; d++) {
        if (datac[i].questionAnswerList[d].fuxuankuang) {
          duo.push(datac[i].questionAnswerList[d].answerContent);
        }
      }
      duo = duo.join(' ');
      datac[i].radio = duo + ' ';
      // datac[i].radio = '吸引顾客  保留顾客 ';
      if (datac[i].answerAnalysis !== datac[i].radio) {
        // console.log(datac[i]);
        dp.seek(0);
        showceshi.value = false;
        window.message.error('答题错误');
        // return console.log('多选题错误');
      }
    }
    // console.log('下一步');
  }
  // console.log(testShuzu);
  window.message.success('答题成功');
  // console.log('下一步');
  // console.log(dtTitle.value);
  // 如果是 章节测试 答题正确 调到下一小节
  if (dtTitle.value === '章节测试') {
    playNext(); // 播放完自动 播放下一下节
  }
  showceshi.value = false;
  dp.play();
}
const answerFlag = ref(true);
function addTestRecordNew (data) {
  addTestRecordNewapi(data).then(res => {
    console.log(data, '答案');
    if (res.data.punish == true) {
      ElMessageBox.alert(res.data.punishMsg, '提示', {
        confirmButtonText: '确定',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false,
        showClose: false,
        callback: () => {
          showceshi.value = false;
          answerFlag.value = true;

          getClassDetailApifun();
        },
      });
    } else {
      if (res.data.simple == true) {
        answerFlag.value = true;
        showceshi.value = false;
        playNext();
      } else {
        // 回答错误
        answerFlag.value = false;
      }
    }
  });
}
const chapterTestInfo = ref(null);
let chapterTestInfotimer = null;
function validationEnd (str, appoint) {
  str = str.toLowerCase(); // 不区分大小写：全部转为小写后进行判断

  var start = str.length - appoint.length; // 相差长度=字符串长度-特定字符长度
  var char = str.substr(start, appoint.length); // 将相差长度作为开始下标，特定字符长度为截取长度

  if (char == appoint) {
    // 两者相同，则代表验证通过
    return true;
  }
  return false;
}
// 章节测试
function sectionTest () {
  if (route.query.type == 1) {
    return;
  }
  dtTitle.value = '章节测试';
  chapterTest({ sectionId: zhangjie.value.sectionId }).then(res => {
    if (JSON.stringify(res.data) !== '{}') {
      console.log('考试');
      testShuzu.value = res.data.questionBankVOList;
      chapterTestInfo.value = res.data;
      // console.log(testShuzu.value);
      // showZhagnjie.value = true;
      answerFlag.value = true;
      showZhagnjie.value = false;
      showceshi.value = true;
      if (chapterTestInfo.value.answerTime > 0) {
        chapterTestInfo.value.answerTimes = chapterTestInfo.value.answerTime * 60;
        clearInterval(chapterTestInfotimer);
        chapterTestInfotimer = setInterval(() => {
          chapterTestInfo.value.answerTimes--;
          if (chapterTestInfo.value.answerTimes <= 0) {
            clearInterval(chapterTestInfotimer);
            // 提交
            tisubmit();
          }
        }, 1000);
        console.log(chapterTestInfo.value);
      }
    } else {
      // console.log('没有考试');
      playNext(); // 播放完自动 播放下一下节
    }
  });
}

// 开始记录（重新记录）
function startRecord () {
  stopRecord();
  handleRecord();
}

// 暂停记录
function pauseRecord () {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
}

// 继续记录
function continueRecord () {
  pauseRecord();
  handleRecord();
}

// 停止记录
function stopRecord () {
  pauseRecord();
  step = 120;
}

// 看视频校验
function videoCheckout () {
  if (isLogin.value) {
    verifyOnlineClass().then(res => {
      // console.log(res.data);
      if (!res.data) {
        dp.pause();
        window.message.error('请您专心线下学习，线下学习期间暂停网络课学习！', { duration: 5000 });
      } else if (recognitionpops) {
        console.log(videoSuperviseList);

        if (!isFinished.value && videoSuperviseList) {
          if (
            videoSuperviseList.supervisePoint &&
            videoSuperviseList.supervisePoint[0] &&
            videoSuperviseList.supervisePoint[0].faceType == 11 &&
            videoSuperviseList.supervisePoint[0].passFlag == 0
          ) {
            recognitionInfo.value = {
              timeLimit: videoSuperviseList.waitingTime * 60,
              actionType: 1,
              ...videoSuperviseList.supervisePoint[0],
            };

            openvideoSupervise();
          } else if (videoSuperviseList.backNeedFace) {
            recognitionInfo.value = {
              timeLimit: -1,
              actionType: 2,
              sectionId: currentGoVoItem.id,
              triggerTime: dp.video.currentTime,
            };
            openvideoSupervise();
          }
        }
      }
      if (!recognitionpops) {
        recognitionpops = true;
      }
    });
  }
}
const centerDialogVisible = ref(false);
const centerDialogVisibles = ref(false);
const openvideoSuppops = ref(true);
const openvideoSuppoptitle = ref('识别失败');
function openvideoSupervise () {
  dp.pause();
  recognitionInfo.value.timeout = false;
  openvideoSuppops.value = true;
  centerDialogVisibles.value = true;
  if (recognitionInfo.value.timeLimit > 0) {
    clearInterval(recognitiontimer);
    recognitiontimer = setInterval(() => {
      recognitionInfo.value.timeLimit--;
      if (recognitionInfo.value.timeLimit <= 0) {
        clearInterval(recognitiontimer);
        recognitionInfo.value.timeout = true;
        let data = {
          ...recognitionInfo.value,
        };
        data.passFlag = 0;
        saveFaceSnapshot(data);
      }
    }, 1000);
  }
}
function recognitionInfoclick () {
  clearInterval(recognitiontimer);
  centerDialogVisible.value = true;
}
function saveFaceSnapshot (data) {
  console.log('saveFaceSnapshot');
  saveFaceSnapshotapi(data).then(res => {
    if (data.passFlag == 1 && res.code == 200) {
      centerDialogVisibles.value = false;
      recognitionpops = false;
      dp.play();
    } else {
      if (res.data.punish) {
      } else {
        window.message.error(res.data.msg, { duration: 5000 });
      }
    }
  });
}
function openss (e) {
  console.log('openss', e);
}
function livingdetect (e) {
  console.log(e);
  centerDialogVisible.value = false;
  if (e.data == true) {
    let datas = {
      faceScore: e.confident,
      faceSnapshot: e.bestImg,
      ...recognitionInfo.value,
    };
    datas.passFlag = 1;
    if (recognitionInfo.value.pointId) {
      videoSuperviseList.supervisePoint.forEach(item => {
        if (item.pointId == recognitionInfo.value.pointId) {
          item.passFlag = 1;
        }
      });
    }
    saveFaceSnapshot(datas);
  } else if (e.data == false) {
    openvideoSuppoptitle.value = '提示' + `(人脸相似度${e.confident}%)`;
    openvideoSuppops.value = false;
    appfaceauditrecordSave2(e.bestImg, e.confident, {
      faceSnapshotId: recognitionInfo.value.pointId,
      actionType: recognitionInfo.value.actionType,
      sectionId: recognitionInfo.value.sectionId,
      triggerTime: recognitionInfo.value.triggerTime,
    });
  } else {
    ElMessage.error(e.msg || '实人认证出错');
  }
}
function appfaceauditrecordSave2 (fileName, confidence, datas) {
  appfaceauditrecordSave({
    failureReason: '11',
    snapFacePictureUrl: fileName,
    passFlag: 0,
    faceScore: confidence,
    ...datas,
  });
}
function handleRecordService (watchTime) {
  if (route.query.type == 1) {
    return;
  }
  recordVideoPlayCreditApi({
    onlineCourseId: route.params.id,
    sectionId: currentGoVoItem.id,
    watchTime: watchTime,
    // watchTime: parseInt(dp.video.currentTime * 1000),
  }).then(res => {
    if (!res.success || res.data === false) {
      // console.log(res);
      // 暂停视频
      dp.pause();
      if (res.data.code === 400) {
        showTips.value = true;
        tipsMsg.value = res.data.msg;
        // 停止记录学分
        stopRecord();
      } else if (res.code === 200 && res.data === false && res.msg === '1') {
        showTips.value = true;
        tipsMsg.value = '您的账号在其他端或网页中学习课程，请关闭其他，再进行学习！';
        // console.log('我是111111');
        // 停止记录学分
        stopRecord();
      } else if (res.code === 200 && res.data === false && res.msg !== '1' && res.msg !== '') {
        dp.pause();
        // 停止记录学分
        stopRecord();

        //
        let obj = res.msg; // 视频跳转 指定位置的时间
        let index = obj.lastIndexOf('#');
        obj = obj.substring(index + 1, obj.length);
        // console.log(obj + '视频跳转 指定位置的时间');

        let Id = res.msg; //
        let Xindex = Id.lastIndexOf('###');
        Id = Id.substring(0, Xindex);
        // console.log(Id + '取出 字符串 ');

        let Xid = Id; // 取出小节 id
        let x = Xid.lastIndexOf('#');
        Xid = Xid.substring(x + 1, Xid.length);
        // console.log(Xid + '小节 的 id');

        // 对比小节id 是同一个id 回到指定播放位置 ,如果不是 刷新页面
        // console.log('视频的id' + zhangjie.value.sectionId);
        if (zhangjie.value.sectionId === Xid) {
          dp.seek(obj / 1000);
          dp.play();
        } else {
          // 刷新浏览器
          setTimeout(() => {
            window.location.reload(true);
          }, 1000);
        }
        window.message.error('敬爱的同学您好，检测到课时异常正在进行课时同步！');
      }
      // showTips.value = true;
     
      // var msg = '您的账号在其他端或网页中学习课程，请关闭其他，再进行学习！';
      // if (!res.data.success && res.data.msg) {
      //   msg = res.data.msg;
      // }
      //
      // tipsMsg.value = msg;
      // 停止记录学分
      // stopRecord();
    } else {
      startRecord();
    }
  });
}

// 记录视频小于60秒的
function lessSixty () {
  if (parseInt(dp.video.duration) <= 60) {
    // console.log(parseInt(dp.video.duration) + '视频总时长@@@@@@@@@@@@@@@@@@@');
    // 记录学分
    handleRecordService(60000);
  }
}

async function handleStudy () {
  // console.log('点击了开始学习11');
  // 跳转上次观看的时间位置
  // console.log('上次观看位置' + zhangjie.value.Gkwatch);
  if (!checkLogin()) {
    return;
  }
  await nextTick();
  if (!dp) {
    return;
  }
  if (dp.video.paused) {
    // recognitionpops = false
    dp.play();
  }
}

let currentGoVo = null;
let currentGoVoIndex = null;
let currentGoVoItem = null;
let currentGoVoItemIndex = null;

function toggleClassVideo ({ group, groupIndex, item, itemIndex }) {
  if (wathc_video_order_need.value && item.sectionLearn <= 1) {
    console.log(item.sectionLearn);
    console.warn('当前课程未播放完毕，请顺序观看');
    ElMessage.warning(`当前课程未播放完毕，请顺序观看`);
    return;
  }
  // 获取视频连接
  resolveAfter2Seconds(item.aliPlay, item.id);
  // console.log('@@@@@@@@@@@@@@@@@@');
  // console.log(item);
  // 判断学习 如果学习为 100% 则显示进度条
  let aa = document.getElementsByClassName('dplayer-bar-wrap');
  if (item.sectionAll === item.sectionLearn || route.query.type == 1) {
    document.getElementsByClassName('dplayer-bar-wrap')[0].style.display = 'block';
    // console.log(aa[0]);
  } else {
    document.getElementsByClassName('dplayer-bar-wrap')[0].style.display = 'none';
  }

  // console.log(group);
  // console.log(groupIndex);
  // console.log(item);
  // console.log(itemIndex);
  // 点击章节下的小节 章节测试 时间储存
  zhangjie.value.sectionId = item.id;
  // zhangjie.value.time = item.sectionAll;

  if (!checkLogin()) {
    return;
  }

  if (item === currentGoVoItem && itemIndex === currentGoVoItemIndex) {
    console.warn('请勿重复点击播放');

    return;
  }
  if (!dp) {
    return;
  }
  currentGoVo = group;
  currentGoVoIndex = groupIndex;
  currentGoVoItem = item;
  currentGoVoItemIndex = itemIndex;
  payVideoId.value = item.id;
  setTimeout(() => {
    let videoUrltype = 'auto';
    if (validationEnd(videoUrl.value, '.m3u8')) {
      videoUrltype = 'customHls';
    }

    dp.switchVideo({
      pic: imgBaseUrl + detailData.value.profilePicture,
      // url: currentGoVoItem.aliPlayUrl,videoUrl.value
      url: videoUrl.value,
      type: videoUrltype,
    });
    // console.log('点击了视频' + videoUrl.value);
  }, 500);

  // 记录 上次 观看视频的位置
  zhangjie.value.Gkwatch = item.sectionLearn;
  if (item.sectionAll !== item.sectionLearn) {
    setTimeout(() => {
      dp.seek(item.sectionLearn * 60);
    }, 1000);
  }
  setTimeout(() => {
    startRecord();
    handleStudy();
  }, 1000);
}

const showTips = ref(false);
const tipsMsg = ref('');

function playNext () {
  // console.log('视频播放完 视频的小标');
  // console.log(currentGoVoItemIndex);
  // console.log(currentGoVoIndex);

  if (!checkLogin()) {
    return;
  }
  let nextVideoInfo = chapterVo.value[currentGoVoIndex].sectionVO[currentGoVoItemIndex + 1];
  if (!nextVideoInfo) {
    if (chapterVo.value.length === currentGoVoIndex + 1) {
      showTips.value = true;
      tipsMsg.value = '当前视频已全部播放完毕';
      return;
    }
    nextVideoInfo = chapterVo.value[currentGoVoIndex + 1];
    if (!nextVideoInfo.sectionVO || nextVideoInfo.sectionVO.length === 0) {
      // window.message.warning('下一章节中无具体视频播放，请手动选择要学习的视频');
      showTips.value = true;
      tipsMsg.value = '下一章节中无具体视频播放，请手动选择要学习的视频';
      return;
    }
    nextVideoInfo = chapterVo.value[currentGoVoIndex + 1].sectionVO[0];
    currentGoVo = chapterVo.value[currentGoVoIndex + 1];
    currentGoVoIndex = currentGoVoIndex + 1;
    currentGoVoItem = nextVideoInfo;
    currentGoVoItemIndex = 0;
    payVideoId.value = currentGoVoItem.id;
  } else {
    currentGoVoItem = nextVideoInfo;
    currentGoVoItemIndex = currentGoVoItemIndex + 1;
    payVideoId.value = nextVideoInfo.id;
  }

  // 获取视频地址
  resolveAfter2Seconds(currentGoVoItem.aliPlay, currentGoVoItem.id);
  zhangjie.value.sectionId = payVideoId.value;
  setTimeout(() => {
    let videoUrltype = 'auto';
    if (validationEnd(videoUrl.value, '.m3u8')) {
      videoUrltype = 'customHls';
    }
    dp.switchVideo({
      pic: imgBaseUrl + detailData.value.profilePicture,
      // url: currentGoVoItem.aliPlayUrl,
      url: videoUrl.value,
      type: videoUrltype,
    });
  }, 500);

  // 视频跳转指定位置
  setTimeout(() => {
    let aa = document.getElementsByClassName('dplayer-bar-wrap');
    if (currentGoVoItem.sectionAll === currentGoVoItem.sectionLearn || route.query.type == 1) {
      dp.seek(0);
      document.getElementsByClassName('dplayer-bar-wrap')[0].style.display = 'block';
    } else {
      document.getElementsByClassName('dplayer-bar-wrap')[0].style.display = 'none';
      dp.seek(currentGoVoItem.sectionLearn * 60);
    }

    startRecord();
    handleStudy();
  }, 1000);
}

// 记录学分 异常提示框 确认按钮
function handleShowTipsConfirm () {
  showTips.value = false;
  // 400
  if (tipsMsg.value.startsWith('未查询到登录用户信息') || tipsMsg.value.startsWith('您的账号')) {
    router.push('/');
  }
}

onBeforeUnmount(() => {
  dp.destroy();
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
});

// onMounted(() => {
document.addEventListener('visibilitychange', function () {
  // 页面变为不可见时触发
  if (document.visibilityState === 'hidden') {
    // document.title = '离开';
    console.log('离开');
    dp.pause();
  }
  // 页面变为可见时触发
  if (document.visibilityState === 'visible') {
    // document.title = '回来';
    // console.log('回来');
  }
});
// });
</script>

<style lang="scss" scoped>
:deep(.n-breadcrumb-item) {
  font-size: 16px;
}

.video-wrapper {
  width: 569px;
  height: 369px;
  margin-right: 70px;
  flex-shrink: 0;
}

:deep(.n-progress-text) {
  font-size: 10px !important;
}

.vhtml img {
  max-width: 100%;
}

.classitem {
  > .relative {
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &.active {
      color: #eb5405;
    }

    &:hover {
      color: #eb5405;
    }
  }
}
</style>

<style lang="scss">
.dplayer-bar-wrap,
.dplayer-setting {
  //display: none !important;
  display: none;
}

.dplayer-setting {
  display: none !important;
}

.dplayer-icons-left,
.dplayer-icons-right {
  bottom: 10px !important;
}
.app-container_onlinedetail {
  max-width: 1465px;
  margin: 0 auto;
}
.onlinedetail_top {
  max-width: 1465px;
  min-height: 521px;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 30px 30px 10px 26px;
  background-color: #fff;
}
</style>
<style>
.n-config-provider {
  background-color: #f4f4f4;
}
.n-tabs-nav-scroll-content {
  height: 69px !important;
}
.n-tabs-tab.n-tabs-tab--active {
  color: #fff !important;
  border-radius: 10px 10px 0 0;
  background-color: #66a6ff !important;
}
.n-tabs-bar {
  display: none !important;
}
</style>
